import React from 'react'
import styles from './index.module.css'
import { CrossIcon } from '../../icons'
import storageService from '../../../app/services/storageService'

const AdditionImagesModal = ({ files, onUpgrade, onClose }) => {
    return (
        <div className={styles.overlay + " requires-no-scroll"}>
            <div className={styles.container}>
                <div className={styles.images}>
                    {files.slice(0, 3).map((file, index) => (
                        <img key={index} src={file.name ? URL.createObjectURL(file) : (!file.file ? `${storageService.publicUrl(file.path)}` : URL.createObjectURL(file.file))} className={styles.image} alt="additional image" />
                    ))}
                    <div style={{ marginLeft: "10px" }}>+{files.length - 3} more</div>
                </div>
                <div className={styles.title}>
                    You have reached your limit of 5 free images. Unlock additional images for <span>$3.00 only</span>
                </div>
                <div className={`banner-submit-button`} style={{display: "flex"}} onClick={onUpgrade}>
                    Unlock unlimited images
                </div>
                <CrossIcon className={styles.cross_icon} onClick={onClose} />
            </div>
        </div>
    )
}

export default AdditionImagesModal